module.exports = __webpack_public_path__ + "static/media/AptAutobook.bd95df1a.svg";